import React, { useState, useEffect } from 'react';
import {
  Stepper,
  Step,
  StepLabel,
  Button,
  Typography,
  CircularProgress,
  Divider,
} from '@mui/material';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
// import { Formik, Form } from 'formik';

import AddressForm from './Forms/AddressForm';
import PersonalForm from './Forms/PersonalForm';
import PaymentForm from './Forms/PaymentForm';
import ReviewOrder from './ReviewOrder';
import CheckoutSuccess from './CheckoutSuccess';
import validationSchema from './FormModel/validationSchema';
import checkoutFormModel from './FormModel/checkoutFormModel';
import formInitialValues from './FormModel/formInitialValues';
import axios from 'axios';
import { useForm, useFieldArray, Controller, useWatch } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import { setFileData } from 'actions/counter';
import UserService from 'services/user.service';
import { formatDateYYYYMMDD } from 'common/DateUtils';
import { useNavigate } from 'react-router-dom';

import useStyles from './styles';

//@001 get employee data
//@002 mapping
//@003 save --> hr.cis.routes2.js --> CIS.js --> insertOrUpdateEmployee

const schema = yup.object().shape({
  firstName: yup
    .string()
    .matches(/^([^0-9]*)$/, 'ต้องไม่ประกอบด้วยตัวเลข')
    .required('ชื่อ isrequired'),
  lastName: yup
    .string()
    .matches(/^([^0-9]*)$/, 'นามสกุลต้องไม่ประกอบด้วยตัวเลข')
    .required('นามสกุล is required'),
  engTitle: yup
    .object()
    .required()
    .typeError('คำนำหน้า(ภาษาอังกฤษ) is required'),
  nameEng: yup
    .string()
    .matches(/^([^0-9]*)$/, 'ชื่อ-นามสกุล(ภาษาอังกฤษ) ต้องไม่ประกอบด้วยตัวเลข')
    .required('ชื่อ-นามสกุล(ภาษาอังกฤษ) is required'),
  idCard: yup.string().required('เลขประจำตัวประชาชน is required'),
  empNationality: yup.string().required('สัญชาติ is required'),
  placeOfBirth: yup.object().required().typeError('ภูมิลำเนา is required'),
  empWeight: yup.number().required().typeError('น้ำหนัก is required'),
  empHeight: yup.number().required().typeError('ส่วนสูง is required'),
  birthdate: yup.mixed().required('วัน/เดือน/ปีเกิด is required'),
  presentAddressEmail: yup
    .string()
    .email('กรุณากรอก email ให้ถูกต้อง')
    .required('email is required'),
  presentAddressCellPhone: yup.string().required('เบอร์โทรศัพท์ is required'),
  royalRankType: yup
    .string()
    .nullable()
    .test(
      'royalRankType-required',
      'ประเภทยศ is required when ยศ is filled',
      function (value) {
        const { royalRank } = this.parent;
        if (royalRank && royalRank !== '') {
          return value && value !== '';
        }
        return true;
      },
    ),
  royalRank: yup
    .string()
    .nullable()
    .test(
      'royalRank-required',
      'ยศ is required when ประเภทยศ is filled',
      function (value) {
        const { royalRankType } = this.parent;
        if (royalRankType && royalRankType !== '') {
          return value && value !== '';
        }
        return true;
      },
    ),
  emergencyFirstName: yup.string().required('ชื่อผู้ติดต่อฉุกเฉิน is required'),
  emergencyLastName: yup
    .string()
    .required('นามสกุลผู้ติดต่อฉุกเฉิน is required'),
  emergencyPhone: yup.string().required('เบอร์โทรศัพท์ is required'),
  medicalProblem: yup.string().required('โรคประจำตัว is required'),
  homeAddressNo: yup
    .string()
    .required('บ้านเลขที่(ที่อยู่ตามทะเบียนบ้าน) is required'),
  homeAddressProvince: yup
    .object()
    .required()
    .typeError('จังหวัด(ที่อยู่ตามทะเบียนบ้าน) is required'),
  homeAddressDistrict: yup
    .object()
    .required()
    .typeError('อำเภอ(ที่อยู่ตามทะเบียนบ้าน) is required'),
  homeAddressTambol: yup
    .object()
    .required()
    .typeError('ตำบล(ที่อยู่ตามทะเบียนบ้าน) is required'),
  homeAddressPostal: yup
    .string()
    .required('รหัสไปรษณีย์(ที่อยู่ตามทะเบียนบ้าน) is required'),
  presentAddressNo: yup
    .string()
    .required('บ้านเลขที่(ที่อยู่ปัจจุบัน) is required'),
  presentAddressProvince: yup
    .object()
    .required()
    .typeError('จังหวัด(ที่อยู่ปัจจุบัน) is required'),
  presentAddressDistrict: yup
    .object()
    .required()
    .typeError('อำเภอ(ที่อยู่ปัจจุบัน) is required'),
  presentAddressTambol: yup
    .object()
    .required()
    .typeError('ตำบล(ที่อยู่ปัจจุบัน) is required'),
  presentAddressPostal: yup
    .string()
    .required('รหัสไปรษณีย์(ที่อยู่ปัจจุบัน) is required'),
  workOnRemoteSite: yup
    .string()
    .required('ปฏิบัติงานต่างจังหวัดเป็นการประจำ is required'),
  workOnRemoteSiteOccasion: yup
    .string()
    .required('ปฏิบัติงานต่างจังหวัดเป็นครั้งคราว is required'),
  educations: yup
    .array()
    .of(
      yup.object().shape({
        eduClass: yup.string().required('ระดับชั้น / หลักสูตร is required'),
        eduNameAndPlace: yup
          .object()
          .required()
          .typeError('ชื่อและที่ตั้งสถานศึกษา is required')
          .test(
            'has-valid-id',
            'ชื่อและที่ตั้งสถานศึกษา is required',
            (value) => {
              // ตรวจสอบว่า object มี id หรือ codeSAP ที่ไม่ว่าง
              return value && value.codeSAP;
            },
          ),
        dateFrom: yup
          .string()
          .nullable()
          .transform((value, originalValue) => {
            return originalValue === '' ? null : value;
          })
          .when('eduClass', {
            is: (eduClass) =>
              ['11', '21', '31', '41', '42', '51', '62', '65'].includes(
                eduClass,
              ),
            then: (schema) =>
              schema
                .required('ระยะเวลาจาก is required')
                .typeError('ระยะเวลาจาก is required'),
            otherwise: (schema) => schema.notRequired(),
          }),
        dateTo: yup
          .string()
          .nullable()
          .transform((value, originalValue) => {
            return originalValue === '' ? null : value;
          })
          .when('eduClass', {
            is: (eduClass) =>
              ['11', '21', '31', '41', '42', '51', '62', '65'].includes(
                eduClass,
              ),
            then: (schema) =>
              schema
                .required('ระยะเวลาถึง is required')
                .typeError('ระยะเวลาถึง is required'),
            otherwise: (schema) => schema.notRequired(),
          }),
        eduGradeScore: yup
          .string()
          .required('เกรดเฉลี่ย/ผลการศึกษา is required'),
        eduCertificate: yup
          .object()
          .required()
          .typeError('ชื่อคุณวุฒิ is required')
          .test('has-valid-id', 'ชื่อคุณวุฒิ is required', (value) => {
            return value && value.codeSAP;
          }),
        branchOfStudy: yup
          .object()
          .required()
          .typeError('สาขาที่จบ is required')
          .test('has-valid-id', 'สาขาที่จบ is required', (value) => {
            return value && value.codeSAP;
          }),
        graduateDate: yup
          .mixed()
          .nullable()
          .transform((value, originalValue) => {
            return originalValue === '' ? null : value;
          })
          .required('วันที่จบการศึกษา is required')
          .typeError('วันที่จบการศึกษา is required'),
        country: yup
          .object()
          .required()
          .typeError('ประเทศ is required')
          .test('has-valid-id', 'ประเทศ is required', (value) => {
            return value && value.id;
          }),
        privateOrGovernment: yup
          .string()
          .required('ประเภทสถานศึกษารัฐบาล/เอกชน is required'),
        duration: yup
          .number()
          .nullable()
          .transform((value, originalValue) => {
            return originalValue === '' ? null : value;
          })
          .when('eduClass', {
            is: (eduClass) => ['11', '21', '31', '41', '51'].includes(eduClass),
            then: (schema) =>
              schema
                .required('ระยะเวลาหลักสูตร is required')
                .typeError('ระยะเวลาหลักสูตร is required'),
            otherwise: (schema) => schema.notRequired(),
          }),
        honors: yup
          .object()
          .required()
          .typeError('เกียรตินิยม is required')
          .test('has-valid-id', 'เกียรตินิยม is required', (value) => {
            return value && value.id;
          }),
        instituteOther: yup
          .string()
          .nullable()
          .when('eduNameAndPlace', {
            is: (eduNameAndPlace) => eduNameAndPlace?.codeSAP === '99999999',
            then: (schema) =>
              schema.required('กรุณาระบุสถาบันอื่นๆ is required'),
            otherwise: (schema) => schema.notRequired(),
          }),
        branchOther: yup
          .string()
          .nullable()
          .when('branchOfStudy', {
            is: (branchOfStudy) => branchOfStudy?.codeSAP === '99999',
            then: (schema) => schema.required('กรุณาระบุสาขาอื่นๆ is required'),
            otherwise: (schema) => schema.notRequired(),
          }),
        certificateOther: yup
          .string()
          .nullable()
          .when('eduCertificate', {
            is: (eduCertificate) => eduCertificate?.codeSAP === 'N/A',
            then: (schema) =>
              schema.required('กรุณาระบุคุณวุฒิอื่นๆ is required'),
            otherwise: (schema) => schema.notRequired(),
          }),
      }),
    )
    .min(1)
    .required(),
  isWorkExperience: yup.string().required('ประสบการณ์ทำงาน is required'),
  workExperience: yup
    .array()
    .of(
      yup.object().shape({
        workName: yup.string().required('ชื่อหน่วยงาน is required'),
        workDuty: yup
          .object()
          .required('ตำแหน่ง is required')
          .typeError('ตำแหน่ง is required')
          .test('has-valid-id', 'ตำแหน่ง is required', (value) => {
            // ตรวจสอบว่า object มี id หรือ codeSAP ที่ไม่ว่าง
            return value && value.codeSAP;
          }),
        workSalary: yup
          .number()
          .transform((value, originalValue) => {
            return originalValue === '' ? undefined : value;
          })
          .required('อัตราเงินเดือน (บาท) is required')
          .typeError('อัตราเงินเดือน (บาท) is required'),
        workPeriod: yup
          .number()
          .transform((value, originalValue) => {
            return originalValue === '' ? undefined : value;
          })
          .required('เป็นระยะเวลา (ปี) is required')
          .typeError('เป็นระยะเวลา (ปี) is required'),
        careerOther: yup
          .string()
          .nullable()
          .when('workDuty', {
            is: (workDuty) => workDuty?.codeSAP === '00000098',
            then: (schema) =>
              schema.required('กรุณาระบุตำแหน่งอื่นๆ is required'),
            otherwise: (schema) => schema.notRequired(),
          }),
        startDate: yup
          .mixed()
          .nullable()
          .transform((value, originalValue) => {
            return originalValue === '' ? null : value;
          })
          .required('วันที่เริ่มงาน is required')
          .typeError('วันที่เริ่มงาน is required'),
        endDate: yup
          .mixed()
          .nullable()
          .transform((value, originalValue) => {
            return originalValue === '' ? null : value;
          })
          .when('isUntilNow', {
            // ถ้าเลือกว่า "ยังทำงานอยู่" ให้ endDate ไม่บังคับ
            is: (flag) =>
              flag === true ||
              flag === 1 ||
              flag === '1' ||
              flag === 'Y' ||
              flag === 'true',
            then: (schema) => schema.notRequired(),
            otherwise: (schema) =>
              schema
                .required('วันที่สิ้นสุดงาน is required')
                .typeError('วันที่สิ้นสุดงาน is required'),
          }),
        isUntilNow: yup.boolean().notRequired(),
      }),
    )
    .when('isWorkExperience', {
      is: (isWorkExperience) => isWorkExperience == 'Y',
      then: (schema) => schema.min(1).required('ประสบการณ์ทำงาน is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
  engineerCert: yup
    .string()
    .required('ใบอนุญาตประกอบวิชาชีพวิศวกรรม is required'),
  engineerCertNo: yup.string().when('engineerCert', {
    is: (engineerCert) => engineerCert == 'Y',
    then: (schema) => schema.required('เลขที่ใบประกอบวิชาชีพ is required'),
    otherwise: (schema) => schema.notRequired(),
  }),
  engineerCertProvider: yup.string().when('engineerCert', {
    is: (engineerCert) => engineerCert == 'Y',
    then: (schema) =>
      schema.required('หน่วยงานผู้ออกใบประกอบวิชาชีพ is required'),
    otherwise: (schema) => schema.notRequired(),
  }),
  engineerCertStartDate: yup
    .date()
    .nullable()
    .transform((value, originalValue) => {
      return originalValue === '' ? null : value;
    })
    .when('engineerCert', {
      is: (engineerCert) => engineerCert == 'Y',
      then: (schema) =>
        schema
          .required('วันที่อนุญาต is required')
          .typeError('วันที่อนุญาต is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
  engineerCertEndDate: yup
    .date()
    .nullable()
    .transform((value, originalValue) => {
      return originalValue === '' ? null : value;
    })
    .when('engineerCert', {
      is: (engineerCert) => engineerCert == 'Y',
      then: (schema) =>
        schema
          .required('วันหมดอายุ is required')
          .typeError('วันหมดอายุ is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
  engineerCertMemberNo: yup.string().when('engineerCert', {
    is: (engineerCert) => engineerCert == 'Y',
    then: (schema) => schema.required('หมายเลขสมาชิกสภาวิศวกร is required'),
    otherwise: (schema) => schema.notRequired(),
  }),
  engineerCertType: yup.string().when('engineerCert', {
    is: (engineerCert) => engineerCert == 'Y',
    then: (schema) => schema.required('ประเภทใบกว. is required'),
    otherwise: (schema) => schema.notRequired(),
  }),
  engineerCertBranch: yup.string().when('engineerCert', {
    is: (engineerCert) => engineerCert == 'Y',
    then: (schema) => schema.required('สาขา is required'),
    otherwise: (schema) => schema.notRequired(),
  }),
  englishLanguageCertificate: yup
    .string()
    .nullable()
    .required('ประกาศณียบัตรทางภาษา is required'),
  englishLanguageCertificateScore: yup
    .string()
    .nullable()
    .when('englishLanguageCertificate', {
      is: (englishLanguageCertificate) =>
        ['TOEIC', 'TOEFL'].includes(englishLanguageCertificate),
      then: (schema) => schema.required('คะแนน is required'),
      otherwise: (schema) => schema.notRequired(),
    }),

  englishLanguageCertificateDate: yup
    .mixed()
    .nullable()
    .when('englishLanguageCertificate', {
      is: (englishLanguageCertificate) =>
        ['TOEIC', 'TOEFL'].includes(englishLanguageCertificate),
      then: (schema) => schema.required('วันที่สอบ is required'),
      otherwise: (schema) => schema.notRequired(),
    }),
  // englishLanguageCertificateNo: yup
  //   .string()
  //   .nullable()
  //   .when('englishLanguageCertificate', {
  //     is: (englishLanguageCertificate) =>
  //       ['TOEIC', 'TOEFL'].includes(englishLanguageCertificate),
  //     then: (schema) => schema.required('เลขที่ประกาศณียบัตร is required'),
  //     otherwise: (schema) => schema.notRequired(),
  //   }),
  isPersonalDataProtectionAct: yup
    .boolean()
    .required('คำรับรองผู้สมัคร is required'),
  acceptConsent: yup.string().required('คำยินยอม is required').nullable(),
});

const steps = [
  'Personal information',
  // 'Address information',
  // 'Education information',
  'Review information',
];

export default function EmploymentPage() {
  const classes = useStyles();
  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const [errMsg, setErrMsg] = useState('');
  const [errMsgDialog, setErrMsgDialog] = useState('');
  const currentValidationSchema = validationSchema[activeStep];
  const { user: currentUser } = useSelector((state) => state.auth);
  const [formValues, setFormValues] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const isLastStep = activeStep === steps.length - 1;
  const { formId, formField } = checkoutFormModel;
  const [isSubmittingFinal, setIsSubmittingFinal] = useState(false);
  const dispatch = useDispatch();

  const {
    control,
    handleSubmit,
    reset,
    getValues,
    setValue,
    formState: { isSubmitting, errors },
  } = useForm({
    defaultValues: {
      title: '---title---',
      positionType: '',
      firstName: '---firstName11---',
      lastName: '---lastName1---',
      isPersonalDataProtectionAct: 0,
      // duputy: 'รวห.',
      // rankingPositions: [{ code: 'AF', label: 'Afghanistan', phone: '93' }],
      placeOfBirth: '---',
    },
    resolver: yupResolver(schema),
  });
  const rhf = {
    useForm,
    useWatch,
    useFieldArray,
    Controller,
    control,
    setValue,
    getValues,
    errors,
  };
  // const { useForm } = rhf;

  console.log('---EmploymentPage---isSubmitting----' + isSubmitting);
  // console.log('---EmploymentPage---errors----' + JSON.stringify(errors));

  async function _submitFormRhf(data) {
    await _sleep(1000);

    //แสดงข้อมูลก่อนส่ง
    // alert(JSON.stringify(data, null, 2));
    // actions.setSubmitting(false);

    // insert TO DB
    const isSuccess = await addEmployee(data);
    if (!isSuccess) {
      alert(errMsg);
    } else {
      setActiveStep(activeStep + 1);
    }
  }

  const onSubmit = (data) => {
    console.log('--------EmploymentPage---onSubmit-------001');
    if (isLastStep) {
      setIsSubmittingFinal(true);
      _submitFormRhf(data);
    } else {
      console.log('--------EmploymentPage---onSubmit-------002');
      setActiveStep(activeStep + 1);
      // actions.setTouched({});
      // actions.setSubmitting(false);
    }
    console.log('data', data);
  };

  //https://codesandbox.io/s/react-hook-form-validation-yup-mrv28?file=/src/index.js:688-747
  const onError = (errors) => {
    console.log('--------EmploymentPage---onError-------');
    console.log(errors);

    let errArr = [];

    // Extract all error messages including nested array errors
    Object.keys(errors).forEach((key) => {
      if (['educations']?.includes(key) && Array.isArray(errors[key])) {
        // Handle educations array errors
        errors[key].forEach((eduErr, index) => {
          if (eduErr) {
            Object.keys(eduErr).forEach((field) => {
              if (eduErr[field]?.message) {
                errArr.push({
                  message: `การศึกษา ${index + 1}: ${eduErr[field].message}`,
                });
              }
            });
          }
        });
      } else if (
        ['workExperience']?.includes(key) &&
        Array.isArray(errors[key])
      ) {
        // Handle workExperience array errors
        errors[key].forEach((workErr, index) => {
          if (workErr) {
            Object.keys(workErr).forEach((field) => {
              if (workErr[field]?.message) {
                errArr.push({
                  message: `ประสบการณ์ทำงาน ${index + 1}: ${
                    workErr[field].message
                  }`,
                });
              }
            });
          }
        });
      } else if (errors[key]?.message) {
        // Handle regular field errors
        errArr.push(errors[key]);
      }
    });

    setErrMsgDialog(errArr);
    handleClickOpenErrorDialog();
  };

  //https://www.geeksforgeeks.org/react-mui-dialogcontent-api/
  function SimpleDialog(props) {
    const { onClose, open } = props;

    const handleClose = () => {
      onClose();
    };

    const render1 = (data) => {
      let v = [];
      //prevent is not a function ถ้ายังไม่มีค่า
      if (data) {
        data.forEach((v2) => {
          // console.log(v2.message);
          // https://www.samanthaming.com/tidbits/87-5-ways-to-append-item-to-array/
          // v = v.concat(v2.message);
          v.push(v2.message);
        });
      }
      return v.map((v2) => (
        <>
          {v2}
          <br />
        </>
      ));
    };

    return (
      <Dialog onClose={handleClose} open={open}>
        <DialogTitle style={{ color: '#4682B4' }}>Required Field</DialogTitle>
        <DialogContent dividers>
          <p style={{ margin: 10 }}>
            {/* Most popular course on DSA trusted by over 75,000 students! Built
            with years of experience by industry experts and gives you a
            complete package of video lectures, practice problems, quizzes,
            discussion forums and contests.
            <br />
            Start Today !
            <br /> */}
            {/* {JSON.stringify(errMsgDialog)} */}
            {render1(errMsgDialog)}
          </p>
        </DialogContent>
      </Dialog>
    );
  }

  //@002 mapping
  const updateForm = (data) => {
    console.log('updateForm: ', data);
    // setFormValues(() => {
    //   return {
    //     ...formInitialValues,
    //     lastName: 'ทดสอบ',
    //   };
    // });
    // const [
    //   {
    //     firstName: vFirstName,
    //     lastName: vLastName,
    //     presentAddress,
    //     durationOfCourse: vDurationOfCourse,
    //   },
    // ] = data;

    //ค่าจาก database
    //create object emp
    const {
      emp: {
        positionType: vPositionType,
        applicantNo: vApplicantNo,
        applicantId,
        title: vTitle,
        idCard: vIdCard,
        firstName: vFirstName,
        lastName: vLastName,
        presentAddress,
        engName: vEngName,
        engTitleId,
        engTitleName,
        nickName: vNickName,
        royalRankType,
        royalRank,
        weight: vEmpWeight,
        height: vEmpHeight,
        bloodGroupId: vBloodType,
        homeAddress: vHomeAddress,
        homeProvinceId,
        homeTambolId,
        homePostalCode: vHomePostalCode,
        presentAddress: vPresentAddressNo,
        // registProvinceId,
        homeProvinceCodeSAP,
        homeProvinceName,
        // registTambolId,
        homeTambolName,
        homeTambolDistrictId,
        homeTambolProvinceId,
        homeDistrictId,
        homeDistrictName,
        homeDistrictProvinceId,
        presentProvinceId,
        presentDistrictId,
        presentTambolId,
        presentProvinceCodeSAP,
        presentProvinceName,
        presentTambolName,
        presentDistrictName,
        presentPostalCode,
        nationality,
        placeOfBirthProvinceId,
        placeOfBirthProvinceCodeSAP,
        placeOfBirthProvinceName,
        medicalProblem,
        mobileNo,
        email,
        emergencyTitle,
        emergencyTitleName,
        emergencyFirstName,
        emergencyLastName,
        emergencyRelationship,
        emergencyAddress,
        emergencyMobileNo,
        workOnRemoteSite,
        workOnRemoteSiteOccasion,
        degreeCode,
        computerSkill: vComputerSkill,
        otherComputerSkill,
        otherSkillDetail: vComment,
        militaryStatusId: vMilitaryStatus,
        militaryExceptReason: vMilitaryExceptReason,
        marriageStatus,
        spouseName,
        numberOfChildren,
        spouseOffice,
        spousePhone,
        birthdate,
        acceptConsent,
        isPersonalDataProtectionAct,
        englishLanguageCertificate,
        englishLanguageCertificateScore,
        englishLanguageCertificateDate,
        englishLanguageCertificateNo,
      },
      edu,
      // edu: [{ durationOfCourse }],
      engineerCert,
      skillLanguage,
      workHistory,
      trainingHistory,
    } = data;

    const transformed = data.edu.map(({ durationOfCourse, startDate }) => ({
      eduPeriod: durationOfCourse,
      eduYearFrom: startDate,
    }));

    const vHomeAddressProvince = {
      id: homeProvinceId,
      codeSAP: homeProvinceCodeSAP,
      name: homeProvinceName,
    };

    const vHomeAddressTambol = {
      id: homeTambolId,
      name: homeTambolName,
      // districtId: registTambolDistrictId,
      // provinceId: registTambolProvinceId,
    };

    // const vRegistAddressTambol = {
    //   id: '2185',
    //   name: 'ตาจง',
    //   // districtId: registTambolDistrictId,
    //   // provinceId: registTambolProvinceId,
    // };

    // console.log(
    //   '-------000001-----vRegistAddressTambol---' +
    //     JSON.stringify(vRegistAddressTambol)
    // );

    const vHomeAddressDistrict = {
      id: homeDistrictId,
      name: homeDistrictName,
      // provinceId: registDistrictProvinceId,
    };

    // console.log(
    //   '-------000002-----vRegistAddressDistrict---' +
    //     JSON.stringify(vRegistAddressDistrict)
    // );

    const vPresentAddressProvince = {
      id: presentProvinceId,
      codeSAP: presentProvinceCodeSAP,
      name: presentProvinceName,
    };

    const vPresentAddressTambol = {
      id: presentTambolId,
      name: presentTambolName,
    };

    const vPresentAddressDistrict = {
      id: presentDistrictId,
      name: presentDistrictName,
    };

    const vPlaceOfBirthProvince = {
      id: placeOfBirthProvinceId,
      codeSAP: placeOfBirthProvinceCodeSAP,
      name: placeOfBirthProvinceName,
    };

    const vWorkHistory = workHistory.map((work) => {
      return {
        workName: work.employer,
        workDuty: { name: work.career || '', codeSAP: work.careerCode || '' },
        careerOther: work.careerOther || null,
        workSalary: work.salaryRate,
        workPeriod: +work.workPeriod,
        startDate: work.startDate,
        endDate: work.endDate,
        isUntilNow: work.isUntilNow,
      };
    });

    const vTrainingHistory = trainingHistory.map((his) => {
      return {
        companyName: his.companyName,
        year: his.trainingYear,
      };
    });

    const vEducation = edu.map((e) => {
      return {
        eduNameAndPlace: {
          id: e?.instituteCode || '',
          codeSAP: e?.instituteCode || '',
          name: e?.instituteName || '',
        },

        // eduNameAndPlace: e?.instituteName || '---',
        // instituteId: e?.instituteId || '',
        // institute: e?.instituteId || '',
        // instituteCode: e?.instituteCode || '',
        dateFrom: e?.dateFrom || '',
        dateTo: e?.dateTo || '',
        eduGradeScore: e?.grade || '',
        eduClass: e?.degreeId || '',
        branchOfStudy: {
          id: e?.branchId || '',
          codeSAP: e?.branchCodeSAP || '',
          name: e?.branchName || '',
        },
        eduCertificate: {
          id: e?.certificateId || '',
          codeSAP: e?.certificateCodeSAP || '',
          name: e?.certificateName || '',
        },
        graduateDate: e?.graduateDate || '',
        inOutCountry: e?.inOutCountry || '',
        countryId: e?.countryId,
        privateOrGovernment: e?.privateOrGovernment || '',
        duration: e?.duration || '',
        isMainEducation: e?.isMainEducation,
        honors: {
          id: e?.honorsId || '',
          name: e?.honorsName || '',
        },
        country: {
          id: e?.countryCode || '',
          name: e?.countryName || '',
        },
        certificateOther: e?.certificateOther || '',
        branchOther: e?.branchOther || '',
        instituteOther: e?.instituteOther || '',
        // eduNameAndPlace: e?.instituteOther || '',
      };
    });

    //ไม่ได้ใช้
    const data2 = {
      ...formInitialValues,
      firstName: vFirstName,
      lastName: vLastName,
      educations: transformed,
      // educations: [
      //   {
      //     eduPeriod: durationOfCourse,
      //     eduYearFrom: '2',
      //     eduYearTo: '3',
      //   },
      // ],
    };
    // setFormValues(data2);

    //react-hook-from initial & transform data

    // console.log('----EmploymentPage.jsx --> homeDistrictId----' + homeDistrictId);

    //mapping DB field to Frontend field
    const dataFromServer = {
      positionType: vPositionType,
      applicantNo: vApplicantNo,
      // salutations: '',
      title: vTitle,
      firstName: vFirstName,
      lastName: vLastName,
      engTitle: engTitleId
        ? {
            id: engTitleId,
            name: engTitleName,
          }
        : null,
      nameEng: vEngName,
      idCard: vIdCard,
      nickName: vNickName,
      empWeight: vEmpWeight,
      empHeight: vEmpHeight,
      royalRankType,
      royalRank,
      bloodType: vBloodType,
      isForeigner: 'N',
      addressPass15yr: [
        {
          // yearFrom: '2020',
          isPresentAddress: '',
          country: { id: 213, codeSAP: 'TH', name: 'ไทย' },
        },
        {
          // yearFrom: '2021',
          isPresentAddress: '',
          country: { id: 213, codeSAP: 'TH', name: 'ไทย' },
        },
      ],
      homeAddressNo: vHomeAddress,
      homeAddressProvince: vHomeAddressProvince,
      // homeAddressProvince: {
      //   id: 11,
      //   codeSAP: '09',
      //   name: 'ชลบุรี',
      // },
      homeAddressDistrict: vHomeAddressDistrict,
      // homeAddressDistrict: { id: 138, name: 'หนองใหญ่' },
      // homeAddressDistrict: {
      //   id: homeDistrictId,
      //   name: homeDistrictName,
      // },
      homeAddressTambol: vHomeAddressTambol,
      homeAddressPostal: vHomePostalCode,
      presentAddressNo: vPresentAddressNo,
      presentAddressProvince: vPresentAddressProvince,
      // presentAddressProvince: { id: 8, codeSAP: '64', name: 'สิงห์บุรี' },
      presentAddressDistrict: vPresentAddressDistrict,
      presentAddressTambol: vPresentAddressTambol,
      presentAddressPostal: presentPostalCode,
      // medicalProblem: '',
      // workOnRemoteSite: '',
      // workOnRemoteSiteOccasion: '',
      // educations: [{ eduClass: '' }],
      // ------------------------------------
      educations: vEducation,
      // ------------------------------------
      // eduOnApplicant: '',
      // engineerCert: '',
      isCollegeActivity: '',
      // collegeActivity: [
      //   {
      //     dateFrom: '',
      //   },
      // ],
      // englishLanguageSkillSpeak: '',
      // englishLanguageSkillRead: '',
      // englishLanguageSkillWrite: '',
      // englishLanguageCertificate: '',
      // othersLanguageSkill: [{ speak: '' }],
      // othersLanguageSkill: [
      // {
      //   languageSkill: [{ id: '', codeSAP: '', name: '' }],
      //   speak: '',
      //   read: '',
      //   write: '',
      //   certificate: '',
      // },
      // {
      //   languageSkill: '2',
      //   speak: '2',
      //   read: '2',
      //   write: '2',
      //   certificate: '2',
      // },
      // ],
      // ------------------------------------
      othersLanguageSkill: [
        {
          languageSkill: {
            id: +skillLanguage[1]?.languageId || '',
            codeSAP: skillLanguage[1]?.codeSAP || '',
            name: skillLanguage[1]?.name || '',
          },
          speak: skillLanguage[1]?.speakingLevelId || '',
          read: skillLanguage[1]?.readingLevelId || '',
          write: skillLanguage[1]?.writingLevelId || '',
          // certificate: skillLanguage[1]?.certificate || '',
        },
      ],
      // ------------------------------------
      // trainingHistory: [{ companyName: '' }],
      // computerSkills: ['2', '3'],
      computerSkills: vComputerSkill?.split(',') || '',
      otherComputerSkill,
      maritalStatus: '',
      isPersonalDataProtectionAct: isPersonalDataProtectionAct || 0,
      empNationality:
        nationality == 'TH' || nationality == null ? 'ไทย' : nationality,
      placeOfBirth: vPlaceOfBirthProvince,
      medicalProblem: medicalProblem ? 'Y' : 'N',
      medicalProblemDetail: medicalProblem,
      presentAddressCellPhone: mobileNo,
      presentAddressEmail: email,
      emergencyTitle: emergencyTitle || '',
      emergencyFirstName,
      emergencyLastName,
      emergencyRelation: emergencyRelationship,
      emergencyAddress,
      emergencyPhone: emergencyMobileNo,
      workOnRemoteSite,
      workOnRemoteSiteOccasion,
      applicantId,
      eduOnApplicant: degreeCode,
      // ------------------------------------
      engineerCert: engineerCert[0] ? 'Y' : 'N',
      engineerCertNo: engineerCert[0]?.engineerCertNo || '',
      engineerCertProvider: engineerCert[0]?.engineerCertProvider || '',
      engineerCertStartDate: engineerCert[0]?.engineerCertStartDate || '',
      engineerCertEndDate: engineerCert[0]?.engineerCertEndDate || '',
      engineerCertMemberNo: engineerCert[0]?.engineerCertMemberNo || '',
      engineerCertType: engineerCert[0]?.engineerCertType || '',
      engineerCertBranch: engineerCert[0]?.engineerCertBranch || '',
      englishLanguageSkillSpeak: skillLanguage[0]?.speakingLevelId || '',
      englishLanguageSkillRead: skillLanguage[0]?.readingLevelId || '',
      englishLanguageSkillWrite: skillLanguage[0]?.writingLevelId || '',
      // englishLanguageCertificate: skillLanguage[0]?.certificate || '',
      // ------------------------------------
      isWorkExperience: vWorkHistory && vWorkHistory.length > 0 ? 'Y' : 'N',
      workExperienceTotal: vWorkHistory?.length || 0,
      workExperience: vWorkHistory || [],
      trainingHistory: vTrainingHistory || '',
      comment: vComment || '',
      militaryStatus: vMilitaryStatus || '',
      militaryStatusReason: vMilitaryExceptReason || '',
      maritalStatus: marriageStatus || '0',
      spouseName,
      numberOfChildren,
      spouseOffice,
      spousePhone,
      birthdate,
      acceptConsent,
      englishLanguageCertificate: ['41', '51'].includes(degreeCode)
        ? 'คะแนนภาษาอังกฤษ กฟผ.'
        : englishLanguageCertificate,
      englishLanguageCertificateScore,
      englishLanguageCertificateDate,
      englishLanguageCertificateNo,
      // inOutCountry: ''
    };

    console.log('----EmploymentPage.jsx --> applicantId----', applicantId);
    console.log('dataFromServer', dataFromServer);
    //react-hook-form ใช้ reset() ในการ set ค่าเริ่มต้น
    reset(dataFromServer);
  };

  // return { ...previousState, formField: { lastname: 'sss' } };

  const getDataFromAPI = () => {
    // Sample API to fetch Data
    console.log('API called!!');
    fetch('https://jsonplaceholder.typicode.com/users')
      .then((response) => {
        return response.json();
      })
      .then((res) => {
        console.log('User data loaded');
        // ไม่ต้อง setIsLoading ที่นี่ เพราะจะรอให้ getEmployeeAndUpdate เสร็จก่อน
      })
      .catch((error) => {
        console.log('Error loading users:', error);
      });
  };

  //@001 get employee data
  const getEmployeeAndUpdate = async () => {
    console.log('getEmployeeAndUpdate', currentUser.username);
    // showLoader();
    try {
      // setErrorMessage('');
      // const { data } = await axios.get('/api/cis/employee', {
      //   params: { employeeId: currentUser.username },
      // });

      // const { data } = await UserService.getEmploymentByEmpNo(idCard);

      const { data } = await UserService.getEmploymentByEmpNo(
        currentUser.username,
      );

      console.log('getEmployeeAndUpdate data', data);
      const {
        emp: {
          firstName: fname,
          lastName,
          presentAddress,
          // isPersonalDataProtectionAct,
        },
        edu: [{ durationOfCourse }],
      } = data;

      // const [
      //   {
      //     emp: { firstName: fname, lastName, presentAddress },
      //   },
      // ] = data;

      console.log(
        '---EmploymentPage.jsx--getEmployeeAndUpdate data --> ',
        data,
      );

      updateForm(data);

      // ประมวลผลเสร็จแล้ว ค่อยปิด loading
      setIsLoading(false);
    } catch (error) {
      if (error.response?.data?.message == 'error') {
        navigate('/app/employment');
      }

      console.log(error.response);
      setIsLoading(false);
    }
  };

  // setIsLoading(false);
  // const {
  //   values: { firstName: f1, file1Name },
  // } = formikProps;
  // console.log('formikProps', f1);
  // const { values, submitForm } = useFormikContext();
  // if (!f1) formikProps.setFieldValue('firstName', fname);
  // if (!f1) formikProps.setFieldValue('file1Name', file1Name);
  // setIsLoading(false);
  // setErrorMessage(
  //   error.response
  //     ? error.response.data.message || 'เกิดข้อผิดพลาดบางอย่าง'
  //     : 'เกิดข้อผิดพลาดบางอย่าง'
  // );

  function _renderStepContent(step) {
    switch (step) {
      case 0:
        // getDataFromAPI();

        // ยังมีปัญหาเรื่อง performance เพราะ render ตลอด
        console.log('_renderStepContent---case 0');

        //เคลียร์ค่าใน redux, แนบไฟล์
        // dispatch(
        //   setFileData({
        //     docType: 'file1Name',
        //     name: '',
        //     url: '',
        //   })
        // );

        // updateForm();
        return (
          <>
            {isLoading && (
              <div
                style={{
                  textAlign: 'center',
                }}
              >
                {/* https://www.geeksforgeeks.org/how-to-use-circularprogress-component-in-reactjs/ */}
                <CircularProgress color="primary" />
              </div>
            )}
            {!isLoading && (
              <PersonalForm
                formField={formField}
                rhf={rhf}
                // errors={errors}
                control={control}
              />
            )}
          </>
          // <PersonalForm formField={formField} />
        );
      // case 1:
      //   console.log('_renderStepContent---case 1');
      //   return <AddressForm formField={formField} rhf={rhf} />;
      // case 2:
      //   return <PaymentForm formField={formField} />;
      // case 3:
      //   return <ReviewOrder rhf={rhf} />;
      case 1:
        return <ReviewOrder rhf={rhf} />;
      default:
        return <div>Not Found</div>;
    }
  }

  function _sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  // async function _submitForm(values, actions) {
  //   await _sleep(1000);
  //   alert(JSON.stringify(values, null, 2));
  //   actions.setSubmitting(false);

  //   //inset TO DB
  //   const isSuccess = await addEmployee(values);
  //   if (!isSuccess) {
  //     alert(errMsg);
  //   } else {
  //     setActiveStep(activeStep + 1);
  //   }
  // }

  // function _handleSubmit(values, actions) {
  //   if (isLastStep) {
  //     _submitForm(values, actions);
  //   } else {
  //     setActiveStep(activeStep + 1);
  //     actions.setTouched({});
  //     actions.setSubmitting(false);
  //   }
  // }

  function _handleBack() {
    setActiveStep(activeStep - 1);
  }

  //@003 save
  //to backend: hr.cis.routes2.js --> CIS.js -- > insertOrUpdateEmployee
  const addEmployee = async (values) => {
    console.log('addEmployee', values);
    try {
      // setErrorMessage('')
      // setIsLoading(true)
      const {
        positionType,
        applicantNo,
        title,
        // idCard,
        firstName,
        lastName,
        address1,
        engTitle,
        nameEng,
        nickName,
        empWeight,
        empHeight,
        bloodType,
        homeAddressNo,
        homeAddressProvince,
        homeAddressTambol,
        homeAddressDistrict,
        homeAddressPostal,
        presentAddressNo,
        presentAddressProvince,
        presentAddressDistrict,
        presentAddressTambol,
        presentAddressPostal,
        empNationality,
        placeOfBirth,
        medicalProblem,
        medicalProblemDetail,
        presentAddressCellPhone,
        presentAddressEmail,
        emergencyTitle,
        emergencyFirstName,
        emergencyLastName,
        emergencyRelation,
        emergencyAddress,
        emergencyPhone,
        workOnRemoteSite,
        workOnRemoteSiteOccasion,
        educations,
        applicantId,
        eduOnApplicant,
        engineerCert,
        engineerCertNo,
        engineerCertProvider,
        engineerCertStartDate,
        engineerCertEndDate,
        engineerCertMemberNo,
        engineerCertType,
        engineerCertBranch,
        englishLanguageSkillSpeak,
        englishLanguageSkillRead,
        englishLanguageSkillWrite,
        englishLanguageCertificate,
        englishLanguageCertificateScore,
        englishLanguageCertificateDate,
        englishLanguageCertificateNo,
        othersLanguageSkill,
        otherComputerSkill,
        workExperience,
        isWorkExperience,
        trainingHistory,
        computerSkills,
        comment,
        militaryStatus,
        militaryStatusReason,
        maritalStatus,
        spouseName,
        numberOfChildren,
        spouseOffice,
        spousePhone,
        birthdate,
        acceptConsent,
        isPersonalDataProtectionAct,
        country,
        royalRankType,
        royalRank,
        // graduateDate,
        // inOutCountry
      } = values;

      // Convert Date objects to YYYY-MM-DD format for educations
      const formattedEducations = educations?.map((edu) => ({
        ...edu,
        dateFrom: edu.dateFrom
          ? formatDateYYYYMMDD(edu.dateFrom)
          : edu.dateFrom,
        dateTo: edu.dateTo ? formatDateYYYYMMDD(edu.dateTo) : edu.dateTo,
        graduateDate: edu.graduateDate
          ? formatDateYYYYMMDD(edu.graduateDate)
          : edu.graduateDate,
      }));

      // Format other date fields
      const formattedEngineerCertStartDate = engineerCertStartDate
        ? formatDateYYYYMMDD(engineerCertStartDate)
        : engineerCertStartDate;
      const formattedEngineerCertEndDate = engineerCertEndDate
        ? formatDateYYYYMMDD(engineerCertEndDate)
        : engineerCertEndDate;
      const formattedEnglishLanguageCertificateDate =
        englishLanguageCertificateDate
          ? formatDateYYYYMMDD(englishLanguageCertificateDate)
          : englishLanguageCertificateDate;

      const data = await axios.post('/api/cis/add-employee', {
        params: {
          positionType,
          applicantNo,
          title,
          idCard: currentUser.username,
          firstName,
          lastName,
          presentAddress: address1,
          engTitle,
          nameEng,
          nickName,
          empWeight,
          empHeight,
          bloodType,
          homeAddressNo, //ที่อยู่ตามทะเบียนบ้าน
          homeAddressProvince,
          homeAddressTambol,
          homeAddressDistrict,
          homeAddressPostal,
          presentAddressNo, //ที่อยู่ปัจจุบันที่สามารถติดต่อได้
          presentAddressProvince,
          presentAddressDistrict,
          presentAddressTambol,
          presentAddressPostal,
          empNationality,
          placeOfBirth,
          medicalProblem,
          medicalProblemDetail,
          presentAddressCellPhone,
          presentAddressEmail,
          emergencyTitle,
          emergencyFirstName,
          emergencyLastName,
          emergencyRelation,
          emergencyAddress,
          emergencyPhone,
          workOnRemoteSite,
          workOnRemoteSiteOccasion,
          educations: formattedEducations,
          applicantId,
          eduOnApplicant,
          engineerCert,
          engineerCertNo,
          engineerCertProvider,
          engineerCertStartDate: formattedEngineerCertStartDate,
          engineerCertEndDate: formattedEngineerCertEndDate,
          engineerCertMemberNo,
          engineerCertType,
          engineerCertBranch,
          englishLanguageSkillSpeak,
          englishLanguageSkillRead,
          englishLanguageSkillWrite,
          englishLanguageCertificate,
          englishLanguageCertificateScore,
          englishLanguageCertificateDate:
            formattedEnglishLanguageCertificateDate,
          englishLanguageCertificateNo,
          othersLanguageSkill,
          otherComputerSkill,
          workExperience,
          isWorkExperience,
          trainingHistory,
          computerSkills,
          comment,
          militaryStatus,
          militaryStatusReason,
          maritalStatus,
          spouseName,
          numberOfChildren,
          spouseOffice,
          spousePhone,
          birthdate,
          acceptConsent,
          isPersonalDataProtectionAct,
          country,
          royalRankType,
          royalRank,
          // graduateDate,
          // inOutCountry
        },
      });
      console.log(
        'EmploymentPage.jsx --> addEmployee --> workOnRemoteSiteOccasion',
        workOnRemoteSiteOccasion,
      );

      return true;
    } catch (error) {
      console.log('error-->frontend-->addEmployee', error);
      setErrMsg(JSON.stringify(error));

      return false;
    }
  };

  // setErrorMessage('');
  // setIsLoading(false);
  // setNickname(nickname);
  // setNicknameInfo('กรุณาเข้าระบบใหม่อีกครั้ง');
  // setOpenNicknameDialog(false);
  // setIsLoading(false);
  // setErrorMessage(
  //   error.response
  //     ? error.response.data.message ||
  //         'เกิดข้อผิดพลาดบางอย่าง โปรดลองอีกครั้ง'
  //     : 'เกิดข้อผิดพลาดบางอย่าง โปรดลองอีกครั้ง'
  // );
  // console.log(error.response)

  const [openErrorDialog, setOpenErrorDialog] = React.useState(false);

  const handleClickOpenErrorDialog = () => {
    setOpenErrorDialog(true);
  };

  const handleCloseErrorDialog = () => {
    setOpenErrorDialog(false);
  };

  useEffect(() => {
    setIsLoading(true); // เริ่มต้น loading
    getDataFromAPI(); // โหลดข้อมูล users (ไม่ต้องรอ)
    getEmployeeAndUpdate(); // โหลดข้อมูลพนักงานและ updateForm แล้วจะปิด loading เมื่อเสร็จ
  }, []);

  return (
    <React.Fragment>
      <Typography
        component="h1"
        variant="h6"
        align="left"
        sx={{ color: 'primary.main' }}
      >
        บันทึกข้อมูลประกอบการจ้าง
        {/* {JSON.stringify(isSubmittingFinal)} */}
      </Typography>
      <Divider sx={{ mb: 3 }} />
      <Stepper activeStep={activeStep} className={classes.stepper}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      <React.Fragment>
        {activeStep === steps.length ? (
          <CheckoutSuccess />
        ) : (
          // <Formik
          //   initialValues={formValues || formInitialValues}
          //   validationSchema={currentValidationSchema}
          //   enableReinitialize
          //   onSubmit={_handleSubmit}
          // >
          //   {({ isSubmitting }) => (

          <form onSubmit={handleSubmit(onSubmit, onError)}>
            {_renderStepContent(activeStep)}

            <SimpleDialog
              open={openErrorDialog}
              onClose={handleCloseErrorDialog}
            />

            <div className={classes.buttons}>
              {activeStep !== 0 && (
                <Button onClick={_handleBack} className={classes.button}>
                  Back
                </Button>
              )}
              <div className={classes.wrapper}>
                <Button
                  disabled={isSubmittingFinal}
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.button}
                >
                  {isLastStep ? 'ส่งข้อมูลให้ HR' : 'Next'}
                </Button>
                {isSubmittingFinal && (
                  <CircularProgress
                    size={24}
                    className={classes.buttonProgress}
                  />
                )}
              </div>
            </div>
          </form>

          //   )}
          // </Formik>
        )}
      </React.Fragment>
    </React.Fragment>
  );
}
